import { Box, Grid, Typography } from '@mui/material';
import { styles } from './styles.ts';

export default function InvalidSessionMessage() {
  return (
    <Grid sx={styles.invalidSessionContainer}>
      <Box sx={styles.invalidSessionBlock}>
        <Typography variant={'h3'} sx={styles.invalidSessionHeader}>
          Це посилання більше не працює
        </Typography>
        <Box sx={styles.invalidSessionContent}>
          <Box sx={styles.textContainer}>
            <Typography variant={'body1'} sx={styles.text}>
              Якщо Ваша активність й досі потрібна, нове посилання вже прийшло Вам на пошту.
              Прогляньте останні листи та використайте останнє відправлене посилання.
            </Typography>
            <Typography variant={'body1'} sx={styles.text}>
              Якщо листа немає - означає що від Вас поки не потрібна ніяка активність.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}
